/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../config/hooks";
import { getProposalDoc } from "../ducks/actions";
import { Card } from "antd";

export default function ProposalBuilder() {
  const dispatch = useAppDispatch();
  const locationUrl = window.location.pathname;
  const pathSegments = locationUrl.split("/");
  const proposalId = pathSegments[pathSegments.length - 1];

  const proposalBuilderData = useAppSelector(
    (state) => state?.potentialDeal?.proposalBuilderData
  );

  useEffect(() => {
    if (proposalId) {
      const payload = {
        proposal_id: proposalId,
      };
      dispatch(getProposalDoc(payload));
    }
  }, [dispatch, proposalId]);

  return (
    <Card
      className="documentEditor additional_card_ui"
      style={{
        margin: 0,
        backgroundColor: "#DBF1EA",
        border: "unset",
        height: "100vh",
      }}
    >
      <div
        className="documentWrapper additional_ui"
        dangerouslySetInnerHTML={{ __html: proposalBuilderData?.data || "" }}
      />
    </Card>
  );
}
